import { z } from 'zod';
import { FuncaoSchema } from './candidatura';
import { CNPJSchema } from './primitives';

/**
 * Phase 11 — profissional response shape with `avatarUrl`.
 *
 * Backend `Profissional` model has many fields, but the public response
 * surface is intentionally narrow at MVP (id + display fields). Add more
 * as features need them.
 */
export const ProfissionalPublicSchema = z.object({
  id: z.string(),
  nomeCompleto: z.string(),
  email: z.string(),
  telefone: z.string(),
  bio: z.string().nullable().optional(),
  funcoes: z.array(FuncaoSchema).optional(),
  /** Phase 11 (MEDIA-02): canonical public URL of processed avatar; null when unset. */
  avatarUrl: z.string().url().nullable().optional(),
});

export type ProfissionalPublic = z.infer<typeof ProfissionalPublicSchema>;

export const ProfissionalMeiUpsertSchema = z.object({
  cnpjMei: CNPJSchema,
});
export type ProfissionalMeiUpsertInput = z.infer<typeof ProfissionalMeiUpsertSchema>;

export const ProfissionalMeiResponseSchema = z.object({
  cnpjMeiMasked: z.string(),
});
export type ProfissionalMeiResponse = z.infer<typeof ProfissionalMeiResponseSchema>;

export const UpdateFuncoesSchema = z.object({
  funcoes: z
    .array(FuncaoSchema)
    .min(1, 'Selecione ao menos uma função')
    .max(3, 'No máximo 3 funções permitidas')
    .refine((arr) => new Set(arr).size === arr.length, 'Funções não podem ser duplicadas'),
});
export type UpdateFuncoesInput = z.infer<typeof UpdateFuncoesSchema>;

